import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { NotificationService } from 'app/_services/notification.service';
import { Globals } from 'app/_globals';
import { CustomBuilderService } from '../../../_services/custom-bulider.service';
import { ObjectFilterPipe } from '../../../_pipes/object-filter.pipe';
import { CategoryService } from '../../../_services/category.service';
import { KioskCategoryService } from '../../../_services/kiosk-category.service';
import { TreeNode, ConfirmationService } from 'primeng/api';
import { CookieService } from 'ngx-cookie-service';
import { ImagesService } from '../../../_services/images.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-single-builder-images',
  templateUrl: './single-builder-images.component.html',
  styleUrls: ['./single-builder-images.component.css'],
})
export class SingleCustomBuilderImagesComponent implements OnInit {
  tabitems: any = [];
  stageitems: any = [];
  customBuilderId: any;
  selectedCustomBuilder: any;
  builderDetailsForm: FormGroup;

  role: any;
  routeRole: any;
  currentStage;

  cookieStore: any;
  storeId: any;

  hasImage = false;

  addMediaModal = false;
  imagesArray: any[] = [];
  imageBase64: any;
  chooseFromImageBank = false;
  uploadNew = false;

  constructor(
    fb: FormBuilder,
    public activatedRoute: ActivatedRoute,
    public loader: LoadingBarService,
    public notificationService: NotificationService,
    public globals: Globals,
    public _customBuilderService: CustomBuilderService,
    public objectFilter: ObjectFilterPipe,
    public _categoryService: CategoryService,
    public _kioskCategoryService: KioskCategoryService,
    public cookieService: CookieService,
    public router: Router,
    public _imagesService: ImagesService,
    public confirmationService: ConfirmationService
  ) {
    // Get builder id from params
    this.activatedRoute.params.subscribe((params: Params) => {
      this.customBuilderId = params.id;
    });

    // Handle Store Cookies
    const hasCurrentStore = cookieService.check('currentStore');
    if (hasCurrentStore) {
      this.cookieStore = JSON.parse(cookieService.get('currentStore'));
      this.storeId = this.cookieStore.id;
    } else {
      this.router.navigate(['/' + this.routeRole + '/select-store']);
    }

    this.role = globals.user.role;
    this.routeRole = globals.user.routeRole;

    this.tabitems = [
      {
        path: '/' + this.routeRole + '/custom-builders/',
        title: 'All Builders',
        class: 'back-link',
      },
      {
        path: '/' + this.routeRole + '/custom-builders/' + this.customBuilderId + '/details',
        title: 'Details',
      },
      {
        path: '/' + this.routeRole + '/custom-builders/' + this.customBuilderId + '/steps',
        title: 'Steps',
      },
      {
        path: '/' + this.routeRole + '/custom-builders/' + this.customBuilderId + '/images',
        title: 'Images',
      },
    ];

    this.builderDetailsForm = fb.group({
      description: new FormControl(),
      basePrice: new FormControl(),
      itemCategory: new FormControl(),
      itemCategoryKiosk: new FormControl(),
      name: new FormControl(),
    });
  }

  ngOnInit() {
    this.getCustomBuilder(this.customBuilderId);
  }

  // Get Custom Builder by id
  public getCustomBuilder(id) {
    this._customBuilderService.getBuilderById(id).subscribe((data: any) => {
      // console.log('Custom Builder - ', data);
      this.selectedCustomBuilder = data;
      if(data.featuredImage){
      this.selectedCustomBuilder.fullImageUrl = environment.dcSpacesUrl + 'images/' + this.storeId + '/' + data.featuredImage.name;
       this.hasImage = true;
       console.log('has image', this.selectedCustomBuilder.fullImageUrl);
      }
    });
  }

  // Add Media Modal
  public toggleAddMediaModal() {
    this.addMediaModal = !this.addMediaModal;
    this.getImages(this.storeId);
  }

  // Get All Images
  public getImages(id) {
    this.imagesArray = [];
    this._imagesService.getAllStoreImages(id).subscribe((data: any) => {
      // console.log(data);
      data.forEach((element) => {
        const obj = {
          imageUrl: environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.name,
          src: environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.name,
          thumb: environment.dcSpacesUrl + 'images/' + this.storeId + '/' + element.name,
          imageData: element,
        };
        this.imagesArray.push(obj);
      });
    });
  }

  public selectImageBankImage(image) {
    this._imagesService
      .addImageToCustomBuilder(this.selectedCustomBuilder.id, image.imageData.id)
      .subscribe((data: any) => {
        this.selectedCustomBuilder.featuredImage = data;
        this.selectedCustomBuilder.fullImageUrl = environment.dcSpacesUrl + 'images/' + this.storeId + '/' + data.name;

        this.hasImage = true;
        this.toggleAddMediaModal();
        this.notificationService.notify(
          'success',
          'Image Added',
          'Category Image has successfully been updated',
          'top',
          'right'
        );
      });
  }

  // Uploading
  public onFileChange(event) {
    for (let i = 0; i < event.target.files.length; i++) {
      const file: File = event.target.files[i];
      const myReader: FileReader = new FileReader();
      const that = this;
      myReader.onloadend = function (loadEvent: any) {
        const fileObj = {
          fileName: event.target.files[i].name,
          imageBase64: loadEvent.target.result,
          customBuilderId: that.selectedCustomBuilder.id,
          itemFeaturedItemId: null,
          itemImageItemId: null,
          storeFeaturedImageStoreId: null,
          storeId: that.storeId,
          storeLogoStoreId: null,
        };
        that.imageBase64 = fileObj;
        that.uploadImage(fileObj);
      };
      myReader.readAsDataURL(file);
    }
  }

  public uploadImage(fileObj) {
    this._imagesService.uploadImageToImageBank(fileObj).subscribe((data: any) => {
      this.imagesArray = [];
      this.getImages(this.storeId);
      this.selectedCustomBuilder.featuredImage = data;
      this.selectedCustomBuilder.fullImageUrl = environment.dcSpacesUrl + 'images/' + this.storeId + '/' + data.name;
      this.hasImage = true;
      this.toggleAddMediaModal();
      this.notificationService.notify(
        'success',
        'Image Uploaded',
        'Image Successfully Uploaded',
        'top',
        'right'
      );
    });
  }

  public removeImage(type) {
    const body = {
      imageId: this.selectedCustomBuilder.featuredImage.id,
      builderFeaturedImageId: this.selectedCustomBuilder.id,
    };
        this._imagesService.removeImageLink(body).subscribe((data: any) => {
          // console.log(data);
          this.selectedCustomBuilder.featuredImage = {} ;
          this.selectedCustomBuilder.fullImageUrl = '';
          this.hasImage = false;
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/custom-builders/single-builder/single-builder-images/single-builder-images.component.ts